"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.uploadSignatureImage = uploadSignatureImage;
exports.fetchSignatureImages = fetchSignatureImages;
exports.batchDeleteSignatureImages = batchDeleteSignatureImages;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _requests = require("@edison/requests");

var _functools = require("@edison/functools");

var _utils = require("./utils");

var _constants = require("../utils/constants");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var endpoints = {
  uploadSignatureImage: {
    method: 'POST',
    url: function url() {
      return "/".concat(_constants.API_V1, "/settings/signature/img/upload");
    }
  },
  listSignatureImages: {
    method: 'GET',
    url: function url() {
      return "/".concat(_constants.API_V1, "/settings/signature/img/list");
    }
  },
  batchDeleteSignatureImages: {
    method: 'POST',
    url: function url() {
      return "/".concat(_constants.API_V1, "/settings/signature/img/batch_delete");
    }
  }
};
/**
 * Upload image for signature
 *
 * @public
 * @param {File} file - Image file to upload
 * @param {Auth} auth - User validated authentication
 * @returns {Promise<String>}
 */

function uploadSignatureImage(_x, _x2) {
  return _uploadSignatureImage.apply(this, arguments);
}
/**
 * Fetch all signature images
 *
 * @public
 * @param {Auth} auth - User validated authentication
 */


function _uploadSignatureImage() {
  _uploadSignatureImage = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(file, auth) {
    var form, options, _endpoints$uploadSign, method, url;

    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            form = new FormData();
            form.append('img', file);
            options = (0, _functools.compose)((0, _utils.withAuth)(auth), (0, _requests.withBody)(form))({});
            _endpoints$uploadSign = endpoints.uploadSignatureImage, method = _endpoints$uploadSign.method, url = _endpoints$uploadSign.url;
            return _context.abrupt("return", fetch(url(), _objectSpread({
              method: method
            }, options)).then(function (res) {
              return res.json();
            }).then(function (res) {
              if (res.status === 1001) {
                throw new Error('Maximum limit of 20 images reached.');
              }

              if (res.status !== 200) {
                throw new Error(res.message);
              }

              return res;
            }));

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _uploadSignatureImage.apply(this, arguments);
}

function fetchSignatureImages(_x3) {
  return _fetchSignatureImages.apply(this, arguments);
}
/**
 * Batch delete signature images
 *
 * @public
 *  @param {Array<string>} imageIds - Ids of images to delete
 * @param {Auth} auth - User validated authentication
 */


function _fetchSignatureImages() {
  _fetchSignatureImages = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(auth) {
    var options, _endpoints$listSignat, method, url, res;

    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            options = (0, _utils.withAuth)(auth)(_utils.defaultOptionals);
            _endpoints$listSignat = endpoints.listSignatureImages, method = _endpoints$listSignat.method, url = _endpoints$listSignat.url;
            _context2.next = 4;
            return (0, _requests.request)(url(), method, options);

          case 4:
            res = _context2.sent;
            return _context2.abrupt("return", res);

          case 6:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _fetchSignatureImages.apply(this, arguments);
}

function batchDeleteSignatureImages(_x4, _x5) {
  return _batchDeleteSignatureImages.apply(this, arguments);
}

function _batchDeleteSignatureImages() {
  _batchDeleteSignatureImages = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(imageIds, auth) {
    var options, _endpoints$batchDelet, method, url, res;

    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            options = (0, _functools.compose)((0, _utils.withAuth)(auth), (0, _requests.withBody)({
              ids: imageIds
            }))(_utils.defaultOptionals);
            _endpoints$batchDelet = endpoints.batchDeleteSignatureImages, method = _endpoints$batchDelet.method, url = _endpoints$batchDelet.url;
            _context3.next = 4;
            return (0, _requests.request)(url(), method, options);

          case 4:
            res = _context3.sent;
            return _context3.abrupt("return", res);

          case 6:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _batchDeleteSignatureImages.apply(this, arguments);
}
//# sourceMappingURL=signature-images.js.map